<template>
  <!--  张雪婷用于测试勿删  -->
  <div class="aboutUs">
    <div class="basic">
      <div class="about-us-title">
        <div class="attachs">
          测试页面
        </div>
      </div>
      <p class="about-us-content">
        测试内容</p>
    </div>

    <div class="bottom-div">
      <p>Copyright©江苏易用科技有限公司 版权所有</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data () {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.aboutUs {
  height: 100%;
  background: #fff;
  @include add_size($font_size_16);
  text-align: justify;
}

.basic {
  padding-top: 20px;
  padding-bottom: 40px;
}

.about-us-title {
  margin: 10px 0;
  text-align: center;
  height: 100px;
}

.about-us-content {
  text-indent: 2em;
  padding-top: 1em;
}

.img {
  width: 100px;
}

.bottom-div {
  background-color: #FFFFFF;
  width: 100%;
  position: fixed;
  bottom: 0;
  text-align: center;
  font-size: 13px;
  padding: 10px;
  color: #999999;
}

</style>
